// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"eba0b41a","453":"30a235a9"}[chunkId] + ".chunk.js";
};